import * as DOM from './utils';
import addDisplayLayerTransparency from './extendDisplayLayerTransparency';
import addDisplayLayerGetFeatureInfo from './extendDisplayLayerGetFeatureInfo';
// import '../static/leaflet.markercluster';

const temaURI = DOM.getQueryString().tema;

export default function displayLayerControl(leaflet) {
    const {
        layerGroup,
        tileLayer,
    } = leaflet;
    const {
        config,
        map,
        state,
    } = this;
    const displayedLayer = layerGroup().addTo(map);

    map.createPane('displayLayers');
    map.getPane('displayLayers').style.zIndex = 300;

    const el = {
        control: DOM.createElement('div', {
            id: 'displayLayerControl',
        }),
        displayLayerContainer: DOM.createElement('div', {
            class: 'displayLayerContainer',
        }),
        divider: DOM.createElement('div', {
            class: 'divider',
        }),
        transparencyContainer: DOM.createElement('div', {
            class: 'transparencyContainer',
        }),
    };

    el.control.appendChild(el.displayLayerContainer);
    el.control.appendChild(el.divider);
    el.control.appendChild(el.transparencyContainer);

    window.app.state.initialised = false;

    const layerEvents = (e) => {
        if (e.target && (e.target.nodeName === 'LI' || e.target.parentElement.nodeName === 'LI')) {
            const target = (e.target.nodeName === 'LI') ? e.target : e.target.parentElement;
            if (window.app.state.initialised === true && DOM.hasClass(target, 'selectedLayer')) {
                return;
            }
            DOM.clearClassQ(el.displayLayerContainer, 'selectedLayer');
            target.classList.add('selectedLayer');

            const _groupID = Number(target.getAttribute('groupID'));
            const _layerID = Number(target.getAttribute('layerID'));

            const container = target.parentElement.parentElement;
            const header = container.querySelector('.groupHeader');
            header.setAttribute('previous', _layerID);

            const displayLayer = state.displayLayers[_groupID][_layerID];
            state.selectedDisplayLayer = config.displayLayers[_groupID].layers[_layerID];
            displayLayer.setOpacity(config.initialDisplayLayerOpacity);
            displayedLayer.clearLayers();
            displayedLayer.addLayer(displayLayer);

            if (state.lastClick) {
                map.fireEvent('click', {
                    latlng: state.lastClick,
                    layerPoint: map.latLngToLayerPoint(state.lastClick),
                    containerPoint: map.latLngToContainerPoint(state.lastClick),
                });
            }

            if (state.selectedDisplayLayer.geojson) {
                const geojsonURL = `${config.connections.geojson}${state.selectedDisplayLayer.geojsonName}&Ticket=${config.ticket}`;
                // const geojsonURL = './static/testJson.json';
                DOM.get(geojsonURL, (err, response) => {
                    if (err) {
                        console.error(err);
                        return;
                    }
                    let json = response;

                    if (typeof response === 'string') {
                        try {
                            json = JSON.parse(response);
                        } catch (parseErr) {
                            console.error(parseErr);
                            return;
                        }
                    }
                    // console.log({json});
                    // debugger;
                    let driftMarkers;
                    if (leaflet.markerClusterGroup) {
                        driftMarkers = leaflet.markerClusterGroup({
                            polygonOptions: config.style.driftMarker,
                        });
                    } else {
                        driftMarkers = leaflet.markerClusterGroup({
                            polygonOptions: config.style.driftMarker,
                        });
                    }

                    const malformedPoints = [];

                    for (let i = 0; i < json.features.length; i += 1) {
                        const point = json.features[i];
                        // console.log('point const ', point);
                        if (point.geometry && point.geometry.coordinates) {
                            let marker = leaflet.circleMarker(point.geometry.coordinates.slice().reverse(), config.style.driftMarker);

                            let displayString = '';
                            for (let z = 0; z < config.geojsonFields.length; z += 1) {
                                displayString += `${point.properties[config.geojsonFields[z]]}</br>`;
                            }
                            // console.log('json_parsed', displayString);

                            // remove link 
                            // if (window.config.displayFaso === true) {
                            //     const fasId = point.properties.TT_URL.split('case_id=')[1].split(' ')[0];
                            //     const fasLink = `<a href="${window.config.connections.fas}${fasId}" target="_blank">Yderligere information</a>`;
                            //     displayString += fasLink;
                            // }

                            let popupContent = document.createElement('div');
                            popupContent.innerHTML = displayString
                                .replace(/\n{2,}/g, '<p>') // Replace consecutive "\n" with </p><p>
                                .replace(/\n/g, '<br>'); // Replace remaining "\n" with <br> // disable link

                            // console.log('popupcontent', popupContent.innerHTML)

                            if (point.properties) {
                                marker.bindPopup(popupContent, {
                                    closeButton: true,
                                    autoClose: false,
                                });
                                marker.on('mouseover', (e) => {
                                    map.closePopup();
                                    //console.log(e);
                                    e.target.openPopup();
                                    
                                });
                            }

                            driftMarkers.addLayer(marker);
                        } else {
                            malformedPoints.push(point);
                        }
                    }

                    if (malformedPoints.length > 0) {
                        console.error('Malformed points:', malformedPoints);
                    }

                    displayedLayer.addLayer(driftMarkers);
                });
            }
        } else if (e.target && e.target.nodeName === 'DIV') {
            if (e.target.classList.contains('groupHeader')) {
                if (!e.target.classList.contains('open')) {
                    DOM.clearClassQ(el.displayLayerContainer, 'open');

                    const previous = Number(e.target.getAttribute('previous'));
                    const layerList = e.target.parentElement.querySelector('ul');
                    layerList.querySelectorAll('LI')[previous].click();

                    layerList.classList.add('open');
                    e.target.classList.add('open');
                } else {
                    DOM.clearClassQ(el.displayLayerContainer, 'open');
                }
            }
        }
    };

    let groupID = 0;
    config.displayLayers.forEach((group) => {
        const groupLayers = [];
        const {
            groupName,
            defaultOpen,
        } = group;
        const groupEl = {
            container: DOM.createElement('div', {
                class: 'groupContainer',
            }),
            header: DOM.createElement('div', {
                class: 'groupHeader',
                previous: 0,
            }),
            headerText: DOM.createElement('h4', {
                class: 'groupHeaderText',
            }),
            layerList: DOM.createElement('ul', {
                class: 'groupLayerList',
            }),
        };
        groupEl.headerText.innerText = groupName;

        let layerID = 0;
        group.layers.forEach((layer) => {
            const layerEl = {
                li: DOM.createElement('li', {
                    class: 'layer',
                    layerID,
                    groupID,
                }),
                info: DOM.createElement('div', {
                    class: 'infoButton',
                }),
                text: DOM.createElement('span'),
                icon: DOM.createElement('div', {
                    class: 'layerIcon',
                }),
            };

            layerEl.text.innerText = layer.text;
            layerEl.info.innerText = 'i';
            layerEl.icon.style.backgroundColor = layer.color;
            layerEl.icon.style.opacity = config.initialDisplayLayerOpacity;

            const popover = {
                wrapper: DOM.createElement('div', {
                    class: 'popover-wrapper',
                }),
                content: DOM.createElement('a', {
                    class: 'popover-content',
                }),
                title: DOM.createElement('h5', {
                    class: 'popover-title',
                }),
                textContainer: DOM.createElement('div', {
                    class: 'popover-text',
                }),
            };

            popover.title.innerText = layer.info.title;
            popover.textContainer.innerHTML = layer.info.text + group.defaultText;
            popover.content.appendChild(popover.title);
            popover.content.appendChild(popover.textContainer);
            popover.wrapper.appendChild(popover.content);
            popover.wrapper.appendChild(layerEl.info);

            const url = `${config.connections.tiles}Ticket=${config.ticket}&Level={z}&X={x}&Y={y}`;

            const groupLayer = tileLayer.wms(url, {
                pane: 'displayLayers',
                maxNativeZoom: 14,
                maxZoom: 19,
                keepBuffer: 4,
                updateWhenIdle: false,
                updateInterval: 150,
                format: 'image/png',
                transparent: true,
                LayerName: layer.name,
                attribution: '&copy; <a href="https://www.niras.dk/">NIRAS A/S</a>',
            });

            if (temaURI && temaURI === layer.name) {
                state.selectedDisplayLayer = config.displayLayers[groupID].layers[layerID];
                groupLayer.setOpacity(config.initialDisplayLayerOpacity);
                displayedLayer.addLayer(groupLayer);
                layerEl.li.classList.add('selectedLayer');
                groupEl.layerList.classList.add('open');
                groupEl.header.classList.add('open');
            } else if (!temaURI && layer.default) {
                state.selectedDisplayLayer = config.displayLayers[groupID].layers[layerID];
                groupLayer.setOpacity(config.initialDisplayLayerOpacity);
                displayedLayer.addLayer(groupLayer);
                layerEl.li.classList.add('selectedLayer');
            }

            groupLayers.push(groupLayer);
            layerID += 1;

            layerEl.li.appendChild(popover.wrapper);
            layerEl.li.appendChild(layerEl.icon);
            layerEl.li.appendChild(layerEl.text);
            groupEl.layerList.appendChild(layerEl.li);
        });

        groupEl.header.appendChild(groupEl.headerText);
        groupEl.container.appendChild(groupEl.header);
        groupEl.container.appendChild(groupEl.layerList);

        if (!temaURI && defaultOpen) {
            groupEl.layerList.classList.add('open');
            groupEl.header.classList.add('open');
        }

        state.displayLayers.push(groupLayers);
        groupID += 1;

        el.displayLayerContainer.appendChild(groupEl.container);
    });

    // console.log(window.app.state.selectedDisplayLayer.geojson);
    el.displayLayerContainer.addEventListener('click', (e) => { layerEvents(e); });


    addDisplayLayerTransparency.call(this, displayedLayer, el.transparencyContainer, el.displayLayerContainer);
    addDisplayLayerGetFeatureInfo.call(this, leaflet);

    this._elements.displayLayerControl = el.control;
    this._elements.interface.appendChild(el.control);

    // mobile button
    const mobEl = {
        container: DOM.createElement('div', {
            id: 'displayLayerControl-mobile',
        }),
    };

    mobEl.container.addEventListener('click', () => {
        if (this._elements.displayLayerControl.style.display === '' || this._elements.displayLayerControl.style.display === 'none') {
            this._elements.displayLayerControl.style.display = 'block';
            if (this._elements.baseLayerControl.style.display === 'block') {
                this._elements.baseLayerControl.style.display = 'none';
            }
        } else {
            this._elements.displayLayerControl.style.display = 'none';
        }
    });

    this._elements.interface.appendChild(mobEl.container);

    document.querySelectorAll('.selectedLayer')[0].click();

    window.app.state.initialised = true;
}
